/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class DimensionPrecomputeVersionState {
    getFixupPrototypeFunction() { return DimensionPrecomputeVersionState.fixupPrototype; }

    static newInstance(model: Partial<DimensionPrecomputeVersionState>): DimensionPrecomputeVersionState {
        let obj = Object.assign(new DimensionPrecomputeVersionState(), model);
        DimensionPrecomputeVersionState.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<DimensionPrecomputeVersionState>): DimensionPrecomputeVersionState {
        if (!model) return null;
        return DimensionPrecomputeVersionState.newInstance(<DimensionPrecomputeVersionState> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: DimensionPrecomputeVersionState) {
        if (!obj) return;

        models.DimensionPrecomputeVersionState.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: DimensionPrecomputeVersionState): boolean {
        Object.setPrototypeOf(obj, DimensionPrecomputeVersionState.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * sys_id of the dimension head version
     */
    version_id: string;

    /**
     * Whether precompute is enabled in the head version
     */
    precompute: boolean;

}
